import { render, staticRenderFns } from "./ProductComparisonBar.vue?vue&type=template&id=65d9ef65&"
import script from "./ProductComparisonBar.vue?vue&type=script&lang=js&"
export * from "./ProductComparisonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports